import { useEffect, useState } from "react";
import JuicyButton from "@/components/base/JuicyButton";

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Full-bleed background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=minimalist%20abstract%20dark%20background%20with%20soft%20gradient%20deep%20navy%20charcoal%20smooth%20texture%20premium%20clean%20modern%20Apple%20style%20wallpaper%20no%20text&width=1600&height=900&seq=hero_bg1&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div
        className={`relative z-10 text-center px-6 max-w-4xl mx-auto w-full transition-all duration-1000 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        {/* Eyebrow */}
        <p
          className="text-white/50 text-xs font-medium tracking-[0.25em] uppercase mb-6"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(12px)",
            transition: "opacity 0.8s ease-out 0.1s, transform 0.8s ease-out 0.1s",
          }}
        >
          Discord Bot
        </p>

        {/* Main headline */}
        <h1
          className="text-6xl md:text-8xl lg:text-9xl font-black text-white leading-none tracking-tight mb-6"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.9s ease-out 0.25s, transform 0.9s ease-out 0.25s",
          }}
        >
          時間割くん
        </h1>

        {/* Sub */}
        <p
          className="text-white/60 text-lg md:text-xl font-light max-w-xl mx-auto mb-10 leading-relaxed"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 0.9s ease-out 0.4s, transform 0.9s ease-out 0.4s",
          }}
        >
          クラスと曜日を選ぶだけで、今日の時間割がすぐわかる。<br />
          Discordでも、このサイトでも使えます。
        </p>

        {/* CTA */}
        <div
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(12px)",
            transition: "opacity 0.9s ease-out 0.55s, transform 0.9s ease-out 0.55s",
          }}
        >
          <JuicyButton
            as="a"
            href="#timetable"
            particleColor="#000000"
            className="inline-flex items-center gap-2 bg-white text-black font-semibold text-sm px-7 py-3 rounded-full whitespace-nowrap cursor-pointer hover:bg-white/90 transition-colors duration-200"
          >
            <i className="ri-calendar-check-line text-base"></i>
            時間割を見る
          </JuicyButton>
        </div>
      </div>

      {/* Scroll hint */}
      <div
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
        style={{
          opacity: visible ? 1 : 0,
          transition: "opacity 1s ease-out 1s",
        }}
      >
        <div className="w-px h-12 bg-gradient-to-b from-transparent to-white/30 animate-pulse" />
      </div>
    </section>
  );
}
